import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 57.47,
			d: "M4783.04 5489.55c8.74 0 17.11 3.29 23.29 9.14 6.18 5.86 9.65 13.79 9.65 22.07v113.74c0 8.28-3.47 16.22-9.65 22.07-6.18 5.86-14.55 9.15-23.29 9.15h-683.01v-176.17z",
			transform: "matrix(.86158 -.86158 .9094 .9094 -8376.19 -742.2)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0054306,
			d: "m605.101 260.81 160.206 160.205M148.457 717.453l-33.326 189.31 193.532-29.104"
		})
	]
});
export default SvgIconPen;
